import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'prop'
})
export class PropPipe implements PipeTransform {

    transform(obj: unknown, path: string): unknown {
        try {
            const paths = path.split('.');
            let current = obj;
            // tslint:disable-next-line:prefer-for-of
            for (let i = 0; i < paths.length; ++i) {
                if (current[paths[i]] === undefined) {
                    return undefined;
                } else {
                    current = current[paths[i]];
                }
            }
            return current;
        } catch (e) {
            return undefined;
        }
    }
}
